import React, { useMemo } from "react"

import { ClarificationRequest } from "shared/types/__generated__/graphql"

import { TeamMemberFragment } from "entities/team-members/graphql/fragments.generated"

import { ClarificationRequestFormContext } from "./ClarificationRequestFormContext"

interface ClarificationRequestFormRootProps {
  children: React.ReactNode
  clarificationRequest: ClarificationRequest | null
  isLoading?: boolean
  lastUpdatedByMember?: TeamMemberFragment | null
}

export function ClarificationRequestFormRoot({
  children,
  clarificationRequest,
  isLoading,
  lastUpdatedByMember = null
}: ClarificationRequestFormRootProps) {
  const contextValue = useMemo(
    () => ({ clarificationRequest, isLoading, lastUpdatedByMember }),
    [clarificationRequest, isLoading, lastUpdatedByMember]
  )

  return (
    <ClarificationRequestFormContext.Provider value={contextValue}>
      <div className="clarification-request-form">{children}</div>
    </ClarificationRequestFormContext.Provider>
  )
}
